module.exports = __webpack_public_path__ + "img/uid-game-guide-1.55cb4ffa.png";